import React, { useState } from 'react';
import { Download, RefreshCw, Loader2, Link2 } from 'lucide-react';
import { settingsAPI } from '../services/api';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Static /favicon.ico (crawled by Google & Bing) : regenerated automatically on favicon change ; manual sync + download + direct link for the Worker/nginx rule
const FaviconSyncRow = () => {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const sync = async () => {
    setBusy(true);
    try { setResult(await settingsAPI.faviconSync()); } catch (e) { setResult({ written: false, reason: e.response?.data?.detail || 'Erreur' }); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 text-xs" data-testid="favicon-sync">
      <p className="text-gray-600 mb-2">Fichier <code>/favicon.ico</code> (lu par Google et Bing dans les résultats de recherche) : régénéré automatiquement à chaque changement d'icône si le dossier du site est accessible. En production, ajoutez la règle <code>/favicon.ico → /api/branding/favicon.ico</code> fournie dans le panneau Pré-rendu (Worker / nginx), ou déposez le fichier téléchargé à la racine du site.</p>
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" onClick={sync} disabled={busy} data-testid="favicon-sync-run" className="inline-flex items-center gap-1 border border-gray-300 rounded-md px-2.5 py-1 bg-white hover:bg-gray-50 text-gray-700">{busy ? <Loader2 size={12} className="animate-spin" /> : <RefreshCw size={12} />} Régénérer maintenant</button>
        <a href={`${BACKEND}/api/branding/favicon.ico`} download="favicon.ico" data-testid="favicon-download" className="inline-flex items-center gap-1 border border-gray-300 rounded-md px-2.5 py-1 bg-white hover:bg-gray-50 text-gray-700"><Download size={12} /> Télécharger favicon.ico</a>
        <a href={`${BACKEND}/api/branding/favicon.ico`} target="_blank" rel="noreferrer" data-testid="favicon-ico-link" className="inline-flex items-center gap-1 text-orange-600 hover:underline"><Link2 size={12} /> /api/branding/favicon.ico</a>
      </div>
      {result && (
        <p className={`mt-2 ${result.written ? 'text-green-700' : 'text-amber-700'}`} data-testid="favicon-sync-result">
          {result.written ? `favicon.ico régénéré (${result.bytes} octets).` : `Fichier non écrit : ${result.reason}. Utilisez la règle Worker/nginx ou le téléchargement.`}
        </p>
      )}
    </div>
  );
};

export default FaviconSyncRow;
